import { message, Modal } from "antd";
import Cookies from "js-cookie";
import { IDLE } from "../../constants/text.constants";
import moment from "moment";

let sessionExpiredModalShown = false;

// Ask Django to renew the Keycloak session on a timer.
export const refreshToken = () => {
  fetch("/oidc/session/refresh/", {
    method: "POST",
    credentials: "same-origin",
    headers: { "X-CSRFToken": Cookies.get("djangocsrftoken") },
  }).then((res) => {
    // An expired session returns 403 (DRF sends no 401 for session auth).
    if (res.status === 401 || res.status === 403) showExpiredSessionModal();
  });
};

// Redirect to Keycloak to re-authenticate once the session has expired.
export const showExpiredSessionModal = () => {
  if (sessionExpiredModalShown) return false;
  Modal.info({
    zIndex: 9999999,
    content:
      "Your session has expired. Click the button below to re-authenticate. You may need to re-enter your credentials if requested.",
    okText: "Re-authenticate",
    onOk() {
      window.location.assign("/oidc/authenticate/");
    },
  });
  message.destroy();
  sessionExpiredModalShown = true;
  return true;
};

export const useSessionIdling = () => {
  let lastActionDateTime = moment();

  const body = document.getElementsByTagName("body")[0];

  const detectActivity = () => {
    lastActionDateTime = moment();
  };

  body.addEventListener("mousemove", detectActivity);
  body.addEventListener("keydown", detectActivity);

  setInterval(() => {
    const duration =
      moment(Date.now()).format("ss") - lastActionDateTime.format("ss");

    if (duration >= 3600) {
      showExpiredSessionModal();
    }
  }, 1000);
};

export const TokenRefresherComponent = () => {
  const checkTime = 60000; // Interval of checking the app is idle. Usually is a minute.
  const startIdle = 50; // When will app considered idle for long.
  const logoutCount = 10; // When will logout is initiated.

  const showIdleMessage = (minutesLeft) => {
    if (sessionExpiredModalShown) return false;
    return message.warn(IDLE(minutesLeft), checkTime + 3000);
  };

  let interaction = 0;
  let idleWarningCount = 0;

  // Any mouse/key down interaction will add the interaction count.
  const body = document.getElementsByTagName("body")[0];
  const addInteraction = () => {
    interaction += 1;
    if (idleWarningCount > 0) {
      refreshToken();
      message.destroy();
      idleWarningCount = 0;
    }
  };
  body.addEventListener("mousedown", addInteraction);
  body.addEventListener("keypress", addInteraction);

  // While the user is active, periodically ask Django to renew the Keycloak
  // session. If they've been idle long enough, prompt to re-authenticate.
  setInterval(() => {
    if (interaction > 0) {
      refreshToken();
      interaction = 0;
      idleWarningCount = 0;
    } else {
      idleWarningCount += 1;
      const logoutTimeLeft = logoutCount + startIdle - idleWarningCount;
      if (idleWarningCount >= startIdle) showIdleMessage(logoutTimeLeft);
      if (logoutTimeLeft === 0) showExpiredSessionModal();
    }
  }, checkTime);

  return null;
};
